import RMCheckBox from 'components/customComponents/Controls/RMCheckbox';
import RMSelect from 'components/customComponents/Controls/RMSelect';
import EReviewExpNameOptions from 'enums/EReviewExpOptions';
import React from 'react';

function ExperimentNameReview({
  prefixCheckboxVal,
  postfixCheckboxVal,
  changePrefixCheckbox,
  changePostfixCheckbox,
  prefixInputVal,
  changePrefixInputVal,
  postfixInputVal,
  changePostfixInputVal,
  firstSelectValue,
  changeScreenSelectValue,
  dateCheckboxValue,
  changeDateCheckbox,
  secondSelectValue,
  changeDateSelectValue,
  thirdCheckbox,
  changeThirdCheckbox,
  thirdSelectValue,
  changeThirdSelectValue,
}: any) {
  const reviewExpOptions = [
    { id: EReviewExpNameOptions.SCREENNAME, name: 'Screen Name' },
    { id: EReviewExpNameOptions.DATE, name: 'Date' },
    { id: EReviewExpNameOptions.TEMPERATURE, name: 'Temperature' },
  ];

  return (
    <div id='experimentnamereview-wrapper' className="flex space-between" style={{ paddingRight: '22px' }}>
      <InputExpNameOption
        id='experimentnamereview-inputexpname'
        checkBoxValue={prefixCheckboxVal}
        changeCheckbox={changePrefixCheckbox}
        inputVal={prefixInputVal}
        changeInput={changePrefixInputVal}
        placeHolder="Prefix"
      />
      <SelectExpNameOption
        id='experimentnamereview-selectexp-first'
        options={reviewExpOptions}
        selectedVal={firstSelectValue}
        changeSelectedVal={changeScreenSelectValue}
        checkBoxValue={true}
        checkboxDiabled={true}
      />
      <SelectExpNameOption
        id='experimentnamereview-selectexp-second'
        options={reviewExpOptions}
        selectedVal={secondSelectValue}
        changeSelectedVal={changeDateSelectValue}
        changeCheckbox={changeDateCheckbox}
        checkBoxValue={dateCheckboxValue}
      />
      <SelectExpNameOption
        id='experimentnamereview-selectexp-third'
        options={reviewExpOptions}
        selectedVal={thirdSelectValue}
        checkBoxValue={thirdCheckbox}
        changeSelectedVal={changeThirdSelectValue}
        changeCheckbox={changeThirdCheckbox}
      />
      <InputExpNameOption
        id='experimentnamereview-inputexp'
        checkBoxValue={postfixCheckboxVal}
        changeCheckbox={changePostfixCheckbox}
        inputVal={postfixInputVal}
        changeInput={changePostfixInputVal}
        placeHolder="Suffix"
      />
    </div>
  );
}

export default ExperimentNameReview;

function ExpNameOption({ children, checkedValue, onChange, disabled = false }: any) {
  return (
    <div id='experimentnamereview-expnameoption'
      className="flex flex-y-center flex-space-between"
      style={{
        flex: '1',
        marginLeft: '13px',
        fontSize: '0.6875rem',
        lineHeight: '0.8125rem',
      }}
    >
      <RMCheckBox
        style={{ width: '17.5%', height: '1.5rem' }}
        onChange={onChange}
        isChecked={checkedValue}
        isDisabled={disabled}
      />
      {children}
    </div>
  );
}

export function InputExpNameOption({
  checkBoxValue,
  changeCheckbox,
  inputVal,
  changeInput,
  placeHolder,
}: any) {
  return (
    <ExpNameOption checkedValue={checkBoxValue} onChange={changeCheckbox}>
      <input
        id='experimentnamereview-inputexpnameoption-input'
        type="text"
        style={{
          width: '73%',
          marginLeft: '11px',
          padding: '4px 7px',
          height: '2.0625rem',
        }}
        value={inputVal}
        onChange={changeInput}
        placeholder={placeHolder}
      />
    </ExpNameOption>
  );
}

export function SelectExpNameOption({
  checkBoxValue,
  changeCheckbox = () => {},
  selectedVal,
  changeSelectedVal = () => {},
  options,
  selectDisabled = false,
  checkboxDiabled = false,
}: any) {
  return (
    <ExpNameOption
      checkedValue={checkBoxValue}
      onChange={changeCheckbox}
      disabled={checkboxDiabled}
    >
      <RMSelect
        placeholder={null}
        options={options}
        onChange={changeSelectedVal}
        selectedValue={selectedVal}
        style={{
          width: '73%',
          marginLeft: '11px',
          fontSize: '0.6875rem',
          lineHeight: '0.8125rem',
          height: '2.0625rem',
        }}
        disabled={selectDisabled}
      />
    </ExpNameOption>
  );
}
